import { createSlice } from '@reduxjs/toolkit';
import {
  userAccountCreate,
  userAccountLogin,
  updateUserInfo,
  resetUserInfo,
  userAccessToken,
  updateInfo,
  updateUserRole,
  forgotPassword,
  updatePassword,
  validateOTP,
  updateQuestions,
  updateMenteeQuestions,
  updateToken,
  menteeUserAssessmentForm,
  getMenteeAssessmentForm,
  menteeSubmitAssesmentForm,
} from '../../services/loginInfo.js';
import { userStatus } from '../../utils/constant';

const initialState = {
  data: {},
  loading: false,
  menteeAssessmentFormData: {},
  status: '',
  error: '',
  otp: '',
};

export const userSlice = createSlice({
  name: 'userInfo',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(userAccountCreate.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(userAccountCreate.fulfilled, (state, action) => {
        const { userResponse = {}, status } = action.payload;
        return {
          ...state,
          data: userResponse,
          status: status === 201 ? userStatus.create : '',
          error: status === 200 ? action.payload?.data?.error || '' : '',
          loading: false,
        };
      })
      .addCase(userAccountCreate.rejected, (state, action) => {
        return {
          ...state,
          loading: false,
          error: action.error.message,
        };
      });
    builder
      .addCase(userAccountLogin.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(userAccountLogin.fulfilled, (state, action) => {
        return {
          ...state,
          data: action.payload,
          status: !Object.keys(action.payload).length
            ? userStatus.pending
            : userStatus.login,
          loading: false,
        };
      })
      .addCase(userAccountLogin.rejected, (state, action) => {
        return {
          ...state,
          loading: false,
          error: action.error.message,
        };
      });
    builder.addCase(updateUserInfo, (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    });
    builder.addCase(resetUserInfo, (state, action) => initialState);
    builder.addCase(updateInfo.fulfilled, (state, action) => {
      return {
        ...state,
        loading: false,
        data: action.payload,
        status: '',
        error: '',
      };
    });
    builder
      .addCase(userAccessToken.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(userAccessToken.fulfilled, (state, action) => {
        return {
          ...state,
          status: userStatus.login,
          loading: false,
        };
      })
      .addCase(userAccessToken.rejected, (state, action) => {
        return {
          ...state,
          loading: false,
          error: action.error.message,
        };
      });
    builder
      .addCase(updateUserRole.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(updateUserRole.fulfilled, (state, action) => {
        return {
          ...state,
          loading: false,
          status: userStatus.role,
          data: action.payload,
        };
      })
      .addCase(updateUserRole.rejected, (state, action) => {
        return {
          ...state,
          loading: false,
          error: action.error.message,
        };
      });

    builder
      .addCase(forgotPassword.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(forgotPassword.fulfilled, (state, action) => {
        return {
          ...state,
          loading: false,
          status: userStatus.otp,
        };
      })
      .addCase(forgotPassword.rejected, (state, action) => {
        console.log('GGG', action);
        return {
          ...state,
          loading: false,
          error: action.error.message,
        };
      });

    builder
      .addCase(validateOTP.pending, (state) => {
        return {
          ...state,
          loading: true,
          error: '',
        };
      })
      .addCase(validateOTP.fulfilled, (state, action) => {
        return {
          ...state,
          loading: false,
          status: userStatus.otpSuccess,
          error: '',
        };
      })
      .addCase(validateOTP.rejected, (state, action) => {
        return {
          ...state,
          loading: false,
          error:
            action.payload?.message ||
            action.payload?.error ||
            action.error?.message ||
            'OTP validation failed.',
        };
      });

    builder
      .addCase(updatePassword.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(updatePassword.fulfilled, (state, action) => {
        return {
          ...state,
          loading: false,
          status: userStatus.changePassword,
        };
      })
      .addCase(updatePassword.rejected, (state, action) => {
        return {
          ...state,
          loading: false,
          error: action.payload?.error ||action.error.message,
        };
      });

    builder
      .addCase(updateQuestions.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(updateQuestions.fulfilled, (state, action) => {
        return {
          ...state,
          loading: false,
          data: action.payload,
          // status : !Object.keys(action.payload).length ? userStatus.pending : userStatus.questions
          status: userStatus.questions,
        };
      })
      .addCase(updateQuestions.rejected, (state, action) => {
        return {
          ...state,
          loading: false,
          error: action.error.message,
        };
      });

    builder
      .addCase(updateMenteeQuestions.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(updateMenteeQuestions.fulfilled, (state, action) => {
        return {
          ...state,
          loading: false,
          data: action.payload,
          status: !Object.keys(action.payload).length
            ? userStatus.pending
            : userStatus.questions,
        };
      })
      .addCase(updateMenteeQuestions.rejected, (state, action) => {
        return {
          ...state,
          loading: false,
          error: action.error.message,
        };
      });

    builder
      .addCase(updateToken.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(updateToken.fulfilled, (state, action) => {
        return {
          ...state,
          loading: false,
          data: action.payload,
          status: !Object.keys(action.payload).length
            ? userStatus.pending
            : userStatus.questions,
        };
      })
      .addCase(updateToken.rejected, (state, action) => {
        return {
          ...state,
          loading: false,
          error: action.error.message,
        };
      });



      builder
      .addCase(menteeUserAssessmentForm.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(menteeUserAssessmentForm.fulfilled, (state, action) => {
        return {
          ...state,
          loading: false,
          status: "done"
        };
      })
      .addCase(menteeUserAssessmentForm.rejected, (state, action) => {
        return {
          ...state,
          loading: false,
          error: action.error.message,
        };
      });

      builder
      .addCase(getMenteeAssessmentForm.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(getMenteeAssessmentForm.fulfilled, (state, action) => {
        return {
          ...state,
          loading: false,
          menteeAssessmentFormData: action?.payload,
          status: "done"
        };
      })
      .addCase(getMenteeAssessmentForm.rejected, (state, action) => {
        return {
          ...state,
          loading: false,
          error: action.error.message,
        };
      });

      builder
      .addCase(menteeSubmitAssesmentForm.pending, (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addCase(menteeSubmitAssesmentForm.fulfilled, (state, action) => {
        return {
          ...state,
          loading: false,
          status: "done"
        };
      })
      .addCase(menteeSubmitAssesmentForm.rejected, (state, action) => {
        return {
          ...state,
          loading: false,
          error: action.error.message,
        };
      });
      
  },
});

export default userSlice.reducer;
